var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirConditioner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "air-conditioner 1",
    clipPath: "url(#clip0_431_683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2 0H9.4C9.1 0 8.9 0.2 9 0.4C9 0.6 9.2 0.8 9.4 0.8H26.3C27.3 0.8 28.1 1.6 28.1 2.6V15.2C28.1 16.2 27.3 17 26.3 17H24.7V13C24.7 12.8 24.5 12.6 24.3 12.6H4.6C4.4 12.6 4.2 12.8 4.2 13V17H2.6C1.6 17 0.8 16.2 0.8 15.2V2.6C0.8 1.6 1.6 0.8 2.6 0.8H7C7.2 0.8 7.4 0.6 7.4 0.4C7.4 0.2 7.2 0 7 0H2.6C1.2 0 0 1.2 0 2.6V15.2C0 16.6 1.2 17.8 2.6 17.8H8.7C8.9 17.8 9.1 17.6 9.1 17.4C9.2 17.2 9 17 8.8 17H5V15.6H17.7C17.9 15.6 18.1 15.4 18.1 15.2C18.1 15 17.9 14.8 17.7 14.8H5V13.4H23.8V14.8H20C19.8 14.8 19.6 15 19.6 15.2C19.6 15.4 19.8 15.6 20 15.6H23.8V17H11.1C10.9 17 10.7 17.2 10.7 17.4C10.7 17.6 10.9 17.8 11.1 17.8H26.2C27.6 17.8 28.8 16.6 28.8 15.2V2.6C28.8 1.2 27.7 0 26.2 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4002 4.39998C22.6002 4.39998 22.8002 4.19998 22.8002 3.99998C22.8002 3.79998 22.6002 3.59998 22.4002 3.59998H20.6002C20.4002 3.59998 20.2002 3.79998 20.2002 3.99998C20.2002 4.19998 20.4002 4.39998 20.6002 4.39998H22.4002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.80039 3.59998C6.50039 3.59998 6.40039 3.79998 6.40039 3.99998C6.40039 4.19998 6.60039 4.39998 6.80039 4.39998H18.0004C18.2004 4.39998 18.4004 4.19998 18.4004 3.99998C18.4004 3.79998 18.2004 3.59998 18.0004 3.59998H6.80039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.4 19.8C5.2 19.8 5 20 5 20.2C4.9 21.4 4.3 22.6 3.2 23.3C3.1 23.4 3.1 23.4 3 23.6C3 23.7 3 23.8 3.1 23.9C3.3 23.9 3.4 24 3.5 24C3.6 24 3.7 24 3.7 23.9C4.9 23 5.7 21.7 5.8 20.2C5.8 20 5.6 19.8 5.4 19.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.6002 19.8C9.4002 19.8 9.2002 20 9.2002 20.2V23.6C9.2002 23.8 9.4002 24 9.6002 24C9.8002 24 10.0002 23.8 10.0002 23.6V20.2C10.0002 20 9.9002 19.8 9.6002 19.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.6002 19.8C14.4002 19.8 14.2002 20 14.2002 20.2V23.6C14.2002 23.8 14.4002 24 14.6002 24C14.8002 24 15.0002 23.8 15.0002 23.6V20.2C15.0002 20 14.8002 19.8 14.6002 19.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.8 20.2C23.8 20 23.6 19.8 23.4 19.8C23.2 19.8 23 20 23 20.2C23.1 21.7 23.8 23.1 25.1 23.9C25.2 23.9 25.2 24 25.3 24C25.4 24 25.5 23.9 25.6 23.8C25.7 23.6 25.7 23.4 25.5 23.3C24.5 22.6 23.9 21.4 23.8 20.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.1998 19.8C18.9998 19.8 18.7998 20 18.7998 20.2V23.6C18.7998 23.8 18.9998 24 19.1998 24C19.3998 24 19.5998 23.8 19.5998 23.6V20.2C19.5998 20 19.3998 19.8 19.1998 19.8Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioner);
export default __webpack_public_path__ + "static/media/air-conditioner.a6d210e95332af8d76a161e95f100594.svg";
export { ForwardRef as ReactComponent };